import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from 'material-ui/SvgIcon';
export const styles = {};
const CustomSvgIconNew = (props) => {
  const {path, ...other} = props;
  return (
    <SvgIcon {...other}>
      <path d={path}/>
    </SvgIcon>
  );
};

CustomSvgIconNew.propTypes = {
  path: PropTypes.string.isRequired,
};

CustomSvgIconNew.defaultProps = {
};

export default CustomSvgIconNew;
